const STORAGE_KEY = "storage" as string;
export type StorageType = "localStorage" | "sessionStorage";
type StorageDataType = object | string | number | null | undefined;
export interface StorageData {
  [index: string]: StorageDataType;
}

export const saveToStorage = (
  key: string,
  data: StorageDataType,
  storage: StorageType = "localStorage",
  storageNamespace: string = STORAGE_KEY
): void => {
  const storageData = getStorage(storage, storageNamespace);
  storageData[key] = data;

  saveStorage(storageData, storage, storageNamespace);
};

export const saveStorage = (
  storageData: StorageData,
  storage: StorageType = "localStorage",
  storageNamespace: string = STORAGE_KEY
): void => {
  window[storage].setItem(storageNamespace, JSON.stringify(storageData));
};

export const purgeStorage = (
  storage: StorageType = "localStorage",
  storageNamespace: string = STORAGE_KEY
): void => {
  window[storage].removeItem(storageNamespace);
};

export const getStorage = (
  storage: StorageType = "localStorage",
  storageNamespace: string = STORAGE_KEY
): StorageData => {
  const storageData = window[storage].getItem(storageNamespace);
  if (!storageData) {
    return {};
  }
  try {
    return JSON.parse(storageData);
  } catch (e) {
    console.warn(e);

    return {};
  }
};

export const getFromStorage = (
  key: string,
  storage: StorageType = "localStorage",
  storageNamespace: string = STORAGE_KEY
): StorageDataType => {
  const storageData = getStorage(storage, storageNamespace);
  try {
    if (key in storageData) {
      return storageData[key];
    }

    return null;
  } catch (e) {
    console.warn(e);

    return null;
  }
};

export const popFromStorage = (
  key: string,
  storage: StorageType = "localStorage",
  storageNamespace: string = STORAGE_KEY
): StorageDataType => {
  const storageKeyData = getFromStorage(key, storage, storageNamespace);
  try {
    deleteFromStorage(key, storage, storageNamespace);

    return storageKeyData;
  } catch (e) {
    console.warn(e);

    return null;
  }
};

export const deleteFromStorage = (
  key: string,
  storage: StorageType = "localStorage",
  storageNamespace: string = STORAGE_KEY
): void => {
  const storageData = getStorage(storage, storageNamespace);
  if (key in storageData) {
    delete storageData[key];
  }

  saveStorage(storageData, storage, storageNamespace);
};

export default {
  saveToStorage,
  purgeStorage,
  getStorage,
  getFromStorage,
  popFromStorage,
  deleteFromStorage,
};
